/**
 * API client for the Soul-Tarot user-ui SPA.
 *
 * Facade: groups every backend call into one ``api`` object and re-exports
 * the shared utilities. The actual implementations live in ``api/``:
 *
 *   api/types.ts    — Pydantic-mirrored interfaces
 *   api/core.ts     — fetch wrapper, Auth, ApiError, formatApiError, SSE helper
 *   api/auth.ts     — OAuth + dev-mode
 *   api/user.ts     — profile, referral, omen, checkin, inbox, avatar
 *   api/reading.ts  — sessions, reviews, SSE start
 *   api/catalog.ts  — mentors, categories, spreads, stardust packs
 *   api/social.ts   — friends + wall
 *   api/billing.ts  — checkout, portal, cancel
 *
 * Auth: JWT bearer in Authorization header. Stored in localStorage
 * (token survives reload; cleared on logout). Web is fine for this —
 * we're not embedding inside another app and CSP can lock down origin.
 */

import { authApi } from './api/auth';
import { billingApi } from './api/billing';
import { catalogApi } from './api/catalog';
import { readingApi } from './api/reading';
import { socialApi } from './api/social';
import { userApi } from './api/user';

export {
  ApiError,
  Auth,
  PendingReferral,
  captureReferralFromURL,
  formatApiError,
  makeSSEAbort,
} from './api/core';

export { parseSSEEvents } from './api/sse';
export type { SSEEvent } from './api/sse';

export type * from './api/types';

export const api = {
  ...authApi,
  ...userApi,
  ...readingApi,
  ...catalogApi,
  ...socialApi,
  ...billingApi,
};
